import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreSystemWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/', component: () => import('./pages/DashboardPage.js') },
    { path: '/admin/modules', component: () => import('./pages/ModulesPage.js') },
    { path: '/admin/settings', component: () => import('./pages/SettingsPage.js') },
    { path: '/admin/design-system', component: () => import('./pages/DesignSystemPage.js') },
  ],
});
